var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaceEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "137px",
    height: "130px",
    viewBox: "0 0 137 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Space End") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0521\\u66F4\\u65B0--space\\u7ED3\\u675F\\u8DF3\\u8F6C",
    transform: "translate(-1181.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(1090.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F-1-\\u526F\\u672C-8",
    transform: "translate(91.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#444487",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 114.036189,
    height: 129.896269
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.826974,117.634028 C117.379628,117.634028 114.90692,117.870164 112.493389,117.587644 C106.740646,116.921401 103.223907,112.350469 103.519786,106.624154 C103.722675,102.689948 104.606087,99.2828326 107.746636,96.4787093 C110.608214,93.9233728 116.749827,93.1896624 119.611404,95.7660824 C122.358857,98.2413011 125.140124,100.826155 124.446921,105.118782 C124.332796,105.852493 124.049597,107.071127 125.313425,107.07956 C126.577253,107.087994 126.530758,105.814542 126.58148,104.920596 C127.130971,96.7991805 120.089039,91.2668349 112.501843,92.2704159 C106.897039,92.9999097 103.600096,96.4070249 102.403898,102.217674 C101.879768,104.781444 100.865324,107.277747 101.473991,109.963802 C102.796995,115.795535 107.433849,119.548422 113.571236,119.662273 C116.978077,119.733958 120.384918,119.662273 123.791759,119.733958 C126.725193,119.792992 128.961197,121.901355 129.049961,124.557893 C129.138753,125.903464 128.665322,127.225688 127.742077,128.210627 C126.818833,129.195566 125.528122,129.755368 124.176403,129.757117 C119.184493,129.892052 114.146087,130.38541 109.200673,129.398695 C96.4398121,126.868659 88.8610699,114.855205 91.5873882,102.833317 C92.9399803,96.8582147 94.7871138,91.2879186 99.8255191,87.2778114 C100.818829,86.4850667 100.856871,85.2959498 101.093574,84.1532168 C101.964305,79.982874 104.187628,77.853427 108.52015,77.7269252 C114.302481,77.5582561 120.334196,76.5504584 125.313425,80.8177859 C125.714976,81.1635575 126.264467,81.4207779 126.509624,81.8466673 C130.093993,88.070556 135.309926,93.4173656 136.700559,100.821938 C137.350749,104.475027 136.937071,108.237507 135.508588,111.663142 C133.877024,115.787101 130.157395,117.461142 125.875596,117.827997 C123.867843,118.000883 121.830501,117.857514 119.810066,117.857514 L119.826974,117.634028 Z M115.177439,105.068182 C115.021045,104.347121 115.426823,103.006202 114.14186,103.31824 C112.856898,103.630278 113.13587,105.182033 112.920301,106.236215 C112.772361,106.957275 112.920301,107.998807 113.841754,107.842788 C115.359193,107.598218 115.033726,106.147664 115.190119,105.068182 L115.177439,105.068182 Z",
    id: "\\u5F62\\u72B6",
    fill: "#D2D2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(106.667934, 86.585255) rotate(-12.240000) translate(-106.667934, -86.585255) ",
    cx: 106.667934,
    cy: 86.5852548,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(112.334311, 85.833697) rotate(-12.240000) translate(-112.334311, -85.833697) ",
    cx: 112.334311,
    cy: 85.8336969,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.993557,88.6229472 C108.993557,88.6229472 110.354603,89.4114751 111.187292,88.1422404",
    id: "\\u8DEF\\u5F84",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5915876,20.2571556 C90.944907,19.2929307 102.299635,18.3273003 113.655773,17.3602643 C118.884386,16.9385916 121.154205,18.8276852 121.598024,23.9847421 C122.680098,36.5590214 123.752309,49.1361119 124.814657,61.7160135 C125.275384,67.1387242 123.483199,69.2513043 117.992521,69.7277944 C110.777288,70.3645202 103.557828,70.9337783 96.3425946,71.5662873 C91.2915087,72.0132604 89.3725188,74.4547452 90.1291249,79.3714486 C90.4630461,81.5388462 90.8181015,83.7062438 91.1604764,85.8736414 C91.2703745,86.5694013 91.6634715,87.345279 90.6109858,87.7079175 C89.5585002,88.070556 89.2034448,87.4000965 88.7131301,86.6242187 C86.7518717,83.5164911 84.5877244,80.5268318 82.6940956,77.3769368 C81.0371703,74.6191975 78.8265277,73.4553809 75.5633994,73.7674187 C67.2914538,74.5601633 59.0110544,75.213756 50.730655,75.8968657 C45.0117268,76.3691391 42.8137648,74.5854637 42.3361307,69.0615516 C41.2371497,56.3832597 40.156485,43.700751 39.0941367,31.0140256 C38.7052665,26.4009265 41.1737469,23.5040352 45.8570969,23.1034462 C57.0948824,22.1476547 68.3397126,21.1988912 79.5915876,20.2571556 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#7575C9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.362974,55.5891095 C74.362974,55.5891095 77.4823894,56.5041392 77.3217691,53.5397802",
    id: "\\u8DEF\\u5F84",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9660138,51.8657397 C78.9660138,51.8657397 82.0854292,52.7807694 81.9459431,49.8164105",
    id: "\\u8DEF\\u5F84",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(81.364093, 56.283912) rotate(-49.860000) translate(-81.364093, -56.283912) ",
    cx: 81.3640931,
    cy: 56.283912,
    rx: 1.70947869,
    ry: 1.05988537
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0649124,110.246322 C45.7755936,110.275324 47.3768716,109.409598 48.2864579,107.963955 C49.1960442,106.518313 49.2814274,104.703361 48.5115587,103.179088 C47.8352627,101.804435 46.5333929,102.137557 45.4259582,102.162857 C43.4351117,102.209241 41.621793,101.989971 40.2438399,100.341231 C39.1793833,99.0559461 38.8383044,97.3209893 39.3372723,95.7298179 C39.8362402,94.1386465 41.1076284,92.9069164 42.7165472,92.4559519 C43.5463986,92.2551045 44.398943,92.1629667 45.2526573,92.1818647 C49.9825026,92.0511461 49.9825026,92.0637963 50.5827153,87.5012979 C51.0899373,83.6472096 53.0807837,81.6611313 56.1663843,81.9267851 C59.2519849,82.1924389 60.8159194,84.4568212 60.6552991,88.3446433 C60.5707621,90.2801209 60.1903456,92.1649978 63.2548119,92.2240319 C68.0269257,92.3167999 68.4453839,92.1776479 68.8046661,88.7072818 C68.8807494,87.9735713 68.8892031,87.2356441 69.0117818,86.5103671 C69.4978695,83.5375747 71.7085121,81.711732 74.5066869,81.9394353 C77.1865099,82.1544883 79.1942637,84.5200721 79.156222,87.4211801 C79.071685,91.8740436 79.071685,91.8740436 83.7212202,92.207165 C87.0350706,92.4433017 89.1442689,94.4420302 89.0766393,97.2672372 C89.0090097,100.092444 86.8702235,102.023705 83.5521462,102.14599 C83.019563,102.167074 82.4869799,102.14599 81.9543968,102.14599 C77.8163106,102.14599 76.0029919,104.45254 76.8821767,108.509031 C76.9848969,109.386419 77.6909001,110.071363 78.5729167,110.149338 C79.4154486,110.23416 80.2624583,110.266551 81.1090268,110.246322 C84.7145299,110.246322 87.0266169,111.933013 87.2252789,114.817254 C87.449302,117.853297 85.221752,120.016478 81.5570729,120.298999 C81.2400591,120.324299 80.9188185,120.33695 80.6018048,120.341166 C75.9311354,120.395984 75.9311354,120.395984 75.1068996,124.760296 C74.4179231,128.386681 72.389035,130.242041 69.4725084,129.930003 C66.5559819,129.617965 64.9962742,127.399967 65.0934917,123.731415 C65.1357602,122.116408 65.7571072,120.307432 62.9208908,120.189364 C58.0811474,119.986961 57.3794903,120.227315 57.0033006,123.267575 C56.9398979,123.790449 56.9229905,124.31754 56.8469072,124.836197 C56.3608194,128.070426 54.2135795,130.128189 51.4914881,129.989037 C48.532693,129.837235 46.5841151,127.518035 46.7870039,124.035019 C46.9138094,121.829671 47.0575223,120.138763 43.8958384,120.172497 C39.5295022,120.218881 37.1793736,118.228586 37.2343226,115.112425 C37.2470032,112.076382 39.846516,110.229455 44.0649124,110.246322 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D2D2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 66.9490789,
    cy: 98.9918784,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 61.8261366,
    cy: 99.6792049,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5827428,103.288723 C62.5827428,103.288723 65.7401998,104.262787 67.9254813,101.91407 C70.1107628,99.5653533 71.8860398,104.94168 68.8427078,106.350067 C65.7993757,107.758453 62.5827428,107.986157 61.4330395,105.696474 C60.346739,103.520643 62.5827428,103.288723 62.5827428,103.288723 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#444487",
    strokeWidth: 0.915029716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#9794D6",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 45.713384,
    height: 129.896269
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7575C9",
    fillRule: "nonzero",
    x: 10.8038289,
    y: 6.19437167,
    width: 10.799602,
    height: 48.0369517
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7575C9",
    fillRule: "nonzero",
    x: 28.4678355,
    y: 6.19437167,
    width: 10.799602,
    height: 48.0369517
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7575C9",
    fillRule: "nonzero",
    x: 10.8038289,
    y: 75.2474898,
    width: 10.799602,
    height: 48.0369517
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7575C9",
    fillRule: "nonzero",
    x: 28.4678355,
    y: 75.2474898,
    width: 10.799602,
    height: 48.0369517
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#444487",
    fillRule: "nonzero",
    cx: 12.012708,
    cy: 64.950243,
    rx: 3.38570694,
    ry: 3.37759817
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7575C9",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 4.50582222,
    height: 129.896269
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceEnd);
export default __webpack_public_path__ + "static/media/space-end.592c4713c2e22c6dd6c5a9363be004bf.svg";
export { ForwardRef as ReactComponent };